import {w3cwebsocket as W3CWebSocket} from 'websocket';

import log from '../logger/log';

const instances = {};

export default class YapWebSocketClient {
    constructor(assetId, createNew = false, options, instanceName) {
        const instance = instances[instanceName];

        if (createNew && instance) {
            instance.disconnectClient();
        }

        if (createNew) {
            instances[instanceName] = this;
            this.assetId = assetId;
            this.instanceName = instanceName;
            this.initClient(options);
        }

        return instances[instanceName];
    }

    initClient(options) {
        this.isConnected = false;
        if (options?.url) {
            const logUrl = options.url.split('?')[0];

            log.info(`yapWebSocketClient: start connection for assetId: ${this.assetId} with url: ${logUrl}`);
            this.client = new W3CWebSocket(options.url);
        } else {
            throw new Error(`Yap Client can't be initialized for assetId: ${this.assetId}.`);
        }
    }

    ping() {
        if (!this.client) return;

        this.client.send('{action: "ping"}');
    }

    isConnectedCheck(assetId) {
        if (this.assetId !== assetId) {
            return false;
        }
        return this.isConnected;
    }

    disconnectClient() {
        if (this.client && this.isConnected) {
            this.client.close(1000);
        }
        instances[this.instanceName] = null;
    }

    disconnectWithReconnectClient() {
        if (this.client && this.isConnected) {
            //4000 - 4999 reserved for private use
            this.client.close(4000);
        }
        instances[this.instanceName] = null;
    }

    attachMessageHandler(onNewMessageHandler) {
        if (!this.client) return;

        this.client.onmessage = (message) => {
            log.info(`yapWebSocketClient: new message for assetId: ${this.assetId} message: ${message?.data}`);
            onNewMessageHandler(message);
        };
    }

    attachConnectHandler(onConnectHandler) {
        if (!this.client) return;

        this.client.onopen = () => {
            this.isConnected = true;
            log.info(`yapWebSocketClient: connected for assetId: ${this.assetId}`);
            onConnectHandler();
        };
    }

    attachCloseHandler(onCloseHandler) {
        if (!this.client) return;

        this.client.onclose = (message) => {
            this.isConnected = false;
            log.info(`yapWebSocketClient: offline for assetId: ${this.assetId}. Message code: ${message.code}`);
            onCloseHandler(message);
        };
    }
}
